import { h } from 'preact';
import PropTypes from 'prop-types';

const SkyItFeatureListsWrapper = ({ children }) => {
  return <div className="s-sky-it-feature-lists-wrapper">{children}</div>;
};

SkyItFeatureListsWrapper.propTypes = {
  children: PropTypes.any,
};

export default SkyItFeatureListsWrapper;
